import { BsTrash } from 'react-icons/bs';
import { FC, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { typeHTHTerritory, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';
import Select from 'react-select';

type propsType = {
    t: typeHTHTerritory;
    users: typeUser[] | null;
};

export const HTHAssignmentsByTerritory: FC<propsType> = ({ t, users }) => {
    const [userToAdd, setUserToAdd] = useState<typeUser | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const assign = (toAssign: number): void => {
        if (!userToAdd) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se va a asignar el territorio ${toAssign} a ${userToAdd.email}`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await houseToHouseServices.AssignTerritory(userToAdd, toAssign, null, false);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                }
                setUserToAdd(null);
            }
        }));
    }

    const unassign = (user: typeUser, toUnassign: number): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se va a desasignar el territorio ${toUnassign} a ${user.email}`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await houseToHouseServices.AssignTerritory(user, null, toUnassign, false);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                }
            }
        }));
    }

    return (
        <div className={'my-5'}>
            <div className={`card ${isDarkMode ? 'text-white' : ''}`}>
                <div className={`card-header ${isDarkMode ? 'bg-success' : ''} d-flex justify-content-between`}>
                    <div className={'fw-bold'}>
                        TERRITORIO {t.territoryNumber} - Edificios: {t.faces.map(x => x.buildings?.length || 0).reduce((a, n) => a + n, 0)}
                    </div>
                </div>
                <div className={`card-body ${isDarkMode ? 'bg-dark' : ''}`}>
                    {users
                     ?.filter(u => u.hthAssignments.some(a => a.territoryId === t.id))
                     .sort((u1, u2) => u1.email.localeCompare(u2.email))
                     .map(u =>
                        <div key={u.id} className={'d-flex justify-content-between pointer hover-primary'}
                            onClick={() => unassign(u, t.number)}
                        >
                            <h5>
                                {u.name} {u.lastName} - {u.email}
                            </h5>
                            <div className={'me-3'}>
                                <BsTrash size={'1.3rem'} />
                            </div>
                        </div>
                    )}
                </div>
                <div className={`card-footer d-flex justify-content-start ${isDarkMode ? 'bg-dark' : ''}`}>
                    <button className={'btn btn-general-blue me-3'}
                        style={{ width: '200px' }}
                        onClick={() => assign(t.number)}
                        disabled={!userToAdd}
                    >
                        Agregar
                    </button>
                    <div className={'w-100'}>
                        <Select options={users?.filter(u => !t.assignments.includes(u.id)) ?? []}
                            className={isDarkMode ? 'text-black' : ''}
                            isClearable
                            getOptionLabel={u => `${u.name} ${u.lastName}`}
                            getOptionValue={u => u?.id?.toString()}
                            value={userToAdd}
                            onChange={u => setUserToAdd(u)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
